module.exports = __webpack_public_path__ + "static/media/flag management skills.ee244746.svg";